import React from "react";
import ExternalLink from "../ReactionTable/externalLink.js";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../Tooltip.js";

// This component is used to display text in the ResultsTable it can be clicked and the serves as a on_click
function ResultInfoText({ text, link = null, onClick = null, navigationLink="", linkText = "Find in external source", row, fontSize="16px", buttonClass="plane-text-button", labelText ="", tooltipText="" }) {
    const content = (
         <>
        {labelText != "" && (<label style={{fontSize: fontSize, marginRight:"5px"}}>{labelText} </label>) } 
        {link && (
            <ExternalLink
                idLink={`link${text}${row}`}
                idDiv={`div${text}${row}`}
                icon={faExternalLink}
                externalLink={link}
            >
                {linkText}
            </ExternalLink>
        )}
        {onClick ? (
        <button
            class={buttonClass}
            style={{fontSize: fontSize}}
            disabled={onClick ? false : true}
            onClick={() => onClick(text)}
        >
            {text}
        </button>) : (navigationLink ?  <a
            class={buttonClass}
            href={navigationLink}
            style={{fontSize: fontSize}}
        >
            {text}
        </a> :  <label class="plane-text-label" style={{fontSize: fontSize}} disabled={true}>{text}</label>)}
        </>
    )
    return tooltipText ? <Tooltip content={tooltipText}>{content}</Tooltip> : content;
}

export default ResultInfoText;